const styles = {
   root: {
      width: '100%',
      minHeight: '81vh',
      margin: '2rem 0',
   },
};

export default styles;
